import { action } from "mobx";
import TourYouTubeVideoRepository from "~/repository/Tour/TourYouTubeVideoRepository";
import NestStore from "../NestStore";

class TourYouTubeVideoStore extends NestStore {
  tourYouTubeVideoRepository = null;

  constructor() {
    super();

    this.tourYouTubeVideoRepository = new TourYouTubeVideoRepository();
  }

  @action
  delete(tourId) {
    return this.tourYouTubeVideoRepository.delete(tourId).catch(error => {
      this.errorMessage = error.message;
      throw error;
    });
  }
}

export default TourYouTubeVideoStore;
